import React from 'react';
import { Droplets, Moon, Activity, CloudFog } from 'lucide-react';
export function MirrorTest() {
  const symptoms = [{
    icon: <Droplets className="w-6 h-6 text-sage" data-id="element-75" />,
    title: 'Facial Puffiness',
    description: 'Noticeable swelling around the jawline and eyes, unrelated to salt intake.'
  }, {
    icon: <Moon className="w-6 h-6 text-sage" data-id="element-76" />,
    title: 'Tired but Wired',
    description: 'Exhausted all day but mind racing at 10 PM when you try to sleep.'
  }, {
    icon: <Activity className="w-6 h-6 text-sage" data-id="element-77" />,
    title: 'Visceral Fat',
    description: 'Weight gain specifically in the midsection that resists diet changes.'
  }, {
    icon: <CloudFog className="w-6 h-6 text-sage" data-id="element-78" />,
    title: 'Brain Fog',
    description: 'Mental clarity issues that caffeine no longer fixes.'
  }];
  return <section className="py-20 lg:py-32 px-6 bg-white relative overflow-hidden" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-81">
          <span className="text-gold font-serif italic text-xl mb-4 block" data-id="element-82">
            Chapter 1
          </span>
          <h2 className="text-4xl lg:text-5xl font-serif text-charcoal mb-6" data-id="element-83">
            The Mirror Test: Is Your Face Telling a Stressed Story?
          </h2>
          <div className="w-24 h-px bg-gold/50 mx-auto mb-8" data-id="element-84"></div>
          <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-85">
            If you are over 30 and feel like your face looks "inflamed" or
            "puffy" even when you haven't gained weight, you aren't imagining
            it. This is <strong data-id="element-86">Cortisol Face</strong>. When your body stays in
            high-alert mode, it retains sodium and creates systemic
            inflammation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-87">
          {symptoms.map((symptom, index) => <div key={index} className="group p-8 bg-cream rounded-sm border border-cream-dark transition-all duration-300 hover:border-sage/30 hover:shadow-md" data-id="element-88">
              <div className="mb-6 p-3 bg-white inline-block rounded-full shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-89">
                {symptom.icon}
              </div>
              <h3 className="text-xl font-serif text-charcoal mb-3 group-hover:text-sage transition-colors" data-id="element-90">
                {symptom.title}
              </h3>
              <p className="text-sm text-charcoal/70 leading-relaxed" data-id="element-91">
                {symptom.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}